import { v4 as uuidv4 } from "uuid";
import { ApiResponse } from "../models/ApiResponse";
import { parseFetchOptions } from "../parseFetchOptions";
import { defaultLogger, sanitize } from "cy-logging";

export * from "../toJsonParsed";

export async function fetchClient(
  url: string,
  options?: Omit<RequestInit, "body"> & { bodyObject?: unknown },
  requestId: string = uuidv4(),
): Promise<ApiResponse> {
  const logger = defaultLogger("fetchClient");
  options = options || {};
  if (
    options.bodyObject != null &&
    typeof options.bodyObject !== "string" &&
    !(options.bodyObject instanceof FormData)
  ) {
    options.bodyObject = JSON.stringify(options.bodyObject);
  }
  const parsedOptions = parseFetchOptions(options, {
    isFormData: options.bodyObject instanceof FormData,
  });

  const body = options.bodyObject as undefined | string | FormData;
  const mergedOptions = {
    ...parsedOptions,
    ...(body ? { body } : undefined),
  };

  // Sanitize body for logging - parse JSON strings/FormData to allow key-based sanitization
  let sanitizedBodyForLogging: unknown = body;
  if (typeof body === "string") {
    try {
      sanitizedBodyForLogging = sanitize(JSON.parse(body));
    } catch {
      sanitizedBodyForLogging = body;
    }
  } else if (body instanceof FormData) {
    sanitizedBodyForLogging = sanitize(Object.fromEntries(body.entries()));
  }

  logger.info(`${mergedOptions.method}: url=${url}, requestId=${requestId}`, {
    requestInit: {
      ...parsedOptions,
      ...(body ? { body: sanitizedBodyForLogging } : undefined),
    },
    requestId,
  });

  const start = Date.now();
  const response = await fetch(url, { ...mergedOptions });
  const serverResponse = new ApiResponse({
    fetchResponse: response,
    method: parsedOptions.method || "GET",
    startTimestamp: start,
    requestId,
    logger,
  });
  return serverResponse;
}
